import { Colors, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column } from '@lightningjs/ui-components';
import PlayButton from './PlayButton';

export default class PaidTitleModal extends Lightning.Component {
  static _template() {
    return {
      Logo: {
        x: 730,
        y: 170,
        w: 470,
        h: 67,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 470, 67),
      },
      Wrapper: {
        zIndex: 200,
        w: 1920,
        h: 1080,
        color: Colors('#000000').get(),
        rect: true,
        collision: true,
        flex: { direction: 'column', alignItems: 'center' },
        Text1: {
          y: 320,
          text: {
            text: 'To watch this title, please upgrade to a paid subscription.',
            textColor: Colors('#fafafa').get(),
            fontFace: 'OpenSans-Regular',
            textAlign: 'center',
            fontSize: 38,
          },
        },
        Text2: {
          y: 340,
          text: {
            text: 'You may upgrade your account',
            textColor: Colors('#fafafa').get(),
            fontFace: 'OpenSans-Regular',
            textAlign: 'center',
            fontSize: 36,
          },
        },
        Text3: {
          w: 240,
          y: 340,
          flex: { direction: 'row', justifyContent: 'space-between' },
          Text4: {
            text: {
              text: 'at ',
              textColor: Colors('#fafafa').get(),
              fontFace: 'OpenSans-Regular',
              textAlign: 'center',
              fontSize: 36,
            },
          },
          Text5: {
            text: {
              text: 'bit.ly/plans',
              textColor: Colors('#02AC25').get(),
              fontFace: 'OpenSans-Regular',
              textAlign: 'center',
              fontSize: 36,
            },
          },
        },

        BtnContainer: {
          collision: true,
          zIndex: 300,
          y: 420,
          w: 235,
          h: 71,
          name: 'Paid',
          type: PlayButton,
          visible: true,
          PlayButton: {
            x: 3,
            y: 3,
            w: 235,
            h: 71,
            type: Column,
            rect: true,
            visible: true,
            color: Colors('#292929').get(),
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 16 },

            Text: {
              x: (235 - 81) / 2,
              y: 12,
              text: {
                fontFace: 'OpenSans-Regular',
                text: 'Close',
                fontSize: 32,
              },
            },
          },
        },
      },
    };
  }

  _getFocused() {
    return this.tag('BtnContainer');
  }

  _handleLeft() {
    return;
  }
  _handleRight() {
    return;
  }
  _handleUp() {
    return;
  }

  _handleDown() {
    return;
  }

  _handleBack() {
    this._handleEnter();
  }

  _handleEnter() {
    this.fireAncestors('$hidePaidTitleModal');
  }

  $setState(state) {
    this._setState('BtnContainer');
  }

  $pressedClick() {
    this._handleEnter();
  }
}
